import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/home/home'
import Process from '@/components/home/process'
// import Notice from '@/components/home/notice'
import Website from '@/components/home/website'
import Wechat from '@/components/home/wechat'
import Login from '@/components/auth/login'
import Register from '@/components/auth/register'
import Authentication from '@/components/auth/authentication'
import FindPass from '@/components/auth/findpass'
import Borrow from '@/components/borrow/borrow'
import BorrowDetail from '@/components/borrow/detail'
// import PerfectInfo from '@/components/user/perfect-info'
import Order from '@/components/user/order'
import OrderList from '@/components/user/order-list'
import OrderDetail from '@/components/user/order-detail'
import OrderProcess from '@/components/user/order-process'
// import ProfileSwitch from '@/components/user/profile-switch'
import Consultant from '@/components/consultant/consultant'
import CaseShare from '@/components/consultant/case-share'
// import ConsultantList from '@/components/consultant/consultant-list'
// import ArticleList from '@/components/consultant/article-list'
import ConsultantArticles from '@/components/consultant/consultant-articles'
import Article from '@/components/consultant/article'
import About from '@/components/about/about'
import Company from '@/components/about/company'
import Perspective from '@/components/about/perspective'
import PerspectiveDetail from '@/components/about/articles'
import Culture from '@/components/about/culture'

Vue.use(Router)

export default new Router({
  linkActiveClass: ' ',
  mode: 'history',
  routes: [{
    path: '/',
    component: Home,
    meta: {
      showSidebar: true
    }
  }, {
    path: '/login',
    component: Login,
    meta: {
      hideFooter: true,
      bgImg: '/static/img/login-bg.png'
    }
  }, {
    path: '/register',
    component: Register,
    meta: {
      hideFooter: true,
      bgImg: '/static/img/login-bg.png'
    }
  }, {
    path: '/authentication',
    component: Authentication,
    meta: {
      requireAuth: true,
      hideFooter: true
    }
  }, {
    path: '/process',
    component: Process
  }, {
    path: '/website',
    component: Website,
    meta: {
      hideFooter: true,
      bgImg: ''
    }
  }, {
    path: '/wechat',
    component: Wechat,
    meta: {
      hideFooter: true,
      bgImg: ''
    }
  }, {
    path: '/findpass',
    component: FindPass
  }, {
    path: '/borrow',
    component: Borrow,
    meta: {
      showSidebar: true
    }
  }, {
    path: '/borrow/:id',
    component: BorrowDetail,
    meta: {
      showSidebar: true,
      showCity: true
    }
  }, {
    path: '/u/order',
    meta: {
      requireAuth: true,
      bgImg: ''
    },
    component: Order,
    children: [{
      path: '/u/order',
      meta: {
        requireAuth: true,
        bgImg: ''
      },
      component: OrderList
    }, {
      path: '/u/order/detail',
      meta: {
        requireAuth: true,
        bgImg: ''
      },
      component: OrderDetail
    }, {
      path: '/u/order/process',
      meta: {
        requireAuth: true,
        bgImg: ''
      },
      component: OrderProcess
    }]
  }, {
    path: '/consultant/counserlor',
    component: Consultant
  },
  {
    path: '/consultant/case-share',
    component: CaseShare
  }, {
    path: '/consultant/consultant-articles/:uid',
    component: ConsultantArticles,
    meta: {
      showCity: true
    }
  }, {
    path: '/consultant/article/:uid',
    component: Article,
    meta: {
      showCity: true
    }
  }, {
    path: '/about',
    component: About,
    children: [{
      path: 'company',
      component: Company
    }, {
      path: 'perspective',
      component: Perspective
    }, {
      path: 'perspective/:id',
      component: PerspectiveDetail
    }, {
      path: 'culture',
      component: Culture
    }, {
      path: 'culture/:id',
      component: PerspectiveDetail
    }]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js